import SignupPage from "#shared/auth/signup/signup-page.tsx";
import {useNewRegistrationFlowFeature} from "#shared/auth/utils/use-new-registration-flow-feature.ts";

import ChooseRole from "./choose-role-page.tsx";
import {withStrings} from "./locales/signup-splitter/load-strings.tsx";

// TODO: Remove this component and replace it in auth-routes.tsx
// once we've rolled out the new signup flow to all users
const SignupSplitter = () => {
    const inExperiment = useNewRegistrationFlowFeature();
    if (inExperiment) {
        return <ChooseRole />;
    }
    return <SignupPage />;
};

export default withStrings()(SignupSplitter);
